<p-dialog [(visible)]="showDialog" [modal]="true">
    <ng-template #header>
        <div>
            <span><i class="pi pi-exclamation-triangle"></i></span>&nbsp;An Error Occurred
        </div>
    </ng-template>
    <div [innerHTML]="errorMessage"></div>
    <br />
    <ng-template #footer>
        <button type="button" class="ui-button-danger" pButton icon="pi pi-times" iconPos="left" label="Close" (click)="showDialog = false"></button>
    </ng-template>
</p-dialog>